import React from "react";
import _ from "underscore";

import "../forms/enquiry2/formProgressIcon.scss";

interface OwnProps {
  isComplete: boolean;
  isPrevComplete: boolean;
  stageTitle: JSX.Element;
}

export class ProgressIcon extends React.Component<OwnProps> {
  public render() {
    const {
      isComplete,
      isPrevComplete,
      stageTitle,
    } = this.props;

    if (isComplete) {
      return (
        <div className="enquire-progress-icon valid">
          <div className="icon-wrap">
            <i className="icon icon-checkmark" />
          </div>
          <div className="bar-bg valid" />
          {stageTitle}
        </div>
      );
    }

    return (
      <div className="enquire-progress-icon unknown">
        <div className="icon-wrap">
          <i className="icon icon-question6" />
        </div>
        {isPrevComplete ? <div className="bar-bg valid" /> : <div className="bar-bg unknown" /> }
        {stageTitle}
      </div>
    );
  }
}
